import React, { type ReactElement, type ReactNode } from 'react';

import classnames from 'classnames';

import { Icon } from 'styled-system';

import styles from './CollapseMenu.module.scss';

type CollapseMenuProps = {
    className?: string;
    collapsedBtnClassName?: string;
    collapseBtnTestId?: string;
    onCollapseBtnClick?: () => void;
    collapseBarTestId?: string;
    onCollapseBarClick?: () => void;
    isCollapsed: boolean;
    setIsCollapsed?: (isCollapsed: boolean) => void;
    renderMenu: (isCollapsed: boolean) => ReactNode;
    scrollableMenu?: boolean;
};

export const CollapseMenu = ({
    className,
    collapsedBtnClassName,
    onCollapseBtnClick,
    collapseBarTestId,
    onCollapseBarClick,
    collapseBtnTestId,
    isCollapsed,
    setIsCollapsed,
    renderMenu,
    scrollableMenu
}: CollapseMenuProps): ReactElement => {
    const handleCollapseBarClick = () => {
        onCollapseBarClick?.();
        setIsCollapsed?.(!isCollapsed);
    };

    const handleCollapseBtnClick = (event: React.MouseEvent) => {
        event.stopPropagation();
        onCollapseBtnClick?.();
        setIsCollapsed?.(!isCollapsed);
    };

    return (
        <div className={classnames(styles.container, className)}>
            {renderMenu(isCollapsed)}
            <div
                data-testid={collapseBarTestId}
                onClick={handleCollapseBarClick}
                className={classnames(styles.bar, {
                    [styles.withinScrollableArea]: scrollableMenu
                })}
            >
                <Icon
                    data-testid={collapseBtnTestId}
                    className={classnames(styles.icon, collapsedBtnClassName, {
                        [styles.withinScrollableArea]: scrollableMenu
                    })}
                    size="medium"
                    onClick={handleCollapseBtnClick}
                    name={
                        isCollapsed ? 's-icon-chevron-right-compact' : 's-icon-chevron-left-compact'
                    }
                />
            </div>
        </div>
    );
};
